_ = require 'underscore'
Util = require 'lib/util'
Auth = require 'db/auth'

class Renderable
  constructor: (args...) ->
    @selected = false
    @reloading = false

    @source = args[0]
    @id = args[0].get('id')
    for attr in @ATTRIBUTES
      @[attr] = args[0].get(attr)

    @_parseAttributes(args...)

  # in case a child class doesn't implement it
  _parseAttributes: ->

  isSearchMatch: (searchTerm) ->
    _.any @SEARCH_FIELDS, (field) =>
      @[field].toLowerCase().indexOf(searchTerm.toLowerCase()) != -1

  toBackbone: ->
    @source

  markAsReloading: ->
    @reloading = true

  markAsReloaded: ->
    @reloading = false

module.exports.Organization = class Organization extends Renderable

  ATTRIBUTES: ['logoHash', 'name', 'displayName']
  API_SEARCH_FIELDS: [
    { fieldName: 'displayName' }
  ]
  SEARCH_FIELDS: ['displayName']

  _parseAttributes: (organization) ->
    @boards = organization.boardList.filter (board) ->
      !board.get('closed')
    @memberCount = organization.get('memberships').length

module.exports.PendingOrganization = class PendingOrganization extends Renderable

  ATTRIBUTES: ['idMember', 'date', 'displayName', 'membershipCount', 'logoHash', 'logoUrl', 'transferability']
  API_SEARCH_FIELDS: [
    { fieldName: 'name' }
    { fieldName: 'displayName' }
  ]
  SEARCH_FIELDS: ['name', 'displayName']

module.exports.PublicBoard = class PublicBoard extends Renderable

  ATTRIBUTES: ['name', 'prefs', 'shortUrl', 'memberships', 'dateLastActivity']
  API_SEARCH_FIELDS: [
    { fieldName: 'name' }
  ]
  SEARCH_FIELDS: ['name']

module.exports.Member = class Member extends Renderable
  # used to search in the main members tab
  API_SEARCH_FIELDS: [
    { fieldName: 'username' }
    { fieldName: 'fullName' }
    {
      fieldName: 'emails.value'
      useIfTermMatches: (term) ->
        Util.checkEmail(term, "A-Z") }
  ]
  # used in popovers
  SEARCH_FIELDS: ['username', 'fullName', 'email']
  ATTRIBUTES: [
    'active'
    'avatarHash'
    'fullName'
    'id'
    'initials'
    'username'
    'email'
    'enterpriseOrgCount'
  ]

  _parseAttributes: (member) ->
    @isDeactivated = !member.get('active')
    @hasTransferred = 'enterprise.owned' in member.get('roles')
    @avatarDomain = window.avatarDomain
    @type = if member.get('memberType') == 'ghost'
        'virtual'
      else if !member.get('confirmed')
        'unconfirmed'
      else if 'enterprise.admin' in member.get('roles')
        'admin'
      else if 'organization.admin' in member.get('roles')
        'team-admin'
      else if member.get('userType') == 'collaborator'
        'collaborator'
    @isMe = Auth.isMe(member)

  orgAdded: (org) ->
    @enterpriseOrgCount++
    @isDeactivated = false
    @type = if @toBackbone().get('memberType') == 'ghost'
        'virtual'
      else if !@toBackbone().get('confirmed')
        'unconfirmed'

  orgRemoved: (org) ->
    return unless @enterpriseOrgCount

    @enterpriseOrgCount--

  orgDeactivated: ->
    @isDeactivated = !@toBackbone().get('active')

  orgReactivated: ->
    @isDeactivated = false



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/renderable-items.coffee